export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_Small.e94dc8b4.jpg";